module.exports = __webpack_public_path__ + "img/rp_02.27315c1c.jpg";